import React from "react";
import imageSrc from "./assets/not-found.svg";

const IconNotFound = ({ style }) => {
  return <img src={imageSrc} alt="Search Results Not Found" style={style} />;
};

export default IconNotFound;
